import React from 'react'

import { StyledLabel, StyledRequired, StyledInternalPlaceholder } from './styles'
import { LabelProps } from './types'

export const Label = ({
  htmlFor,
  children,
  labelPosition = 'internal',
  surfaceColor = 'light',
  status,
  placeholder,
  required,
  disabled,
  ...props
}: LabelProps) => {
  return (
    <StyledLabel
      htmlFor={htmlFor}
      labelPosition={labelPosition}
      surfaceColor={surfaceColor}
      status={status}
      disabled={disabled}
      {...props}
    >
      <span>{children}</span>
      {required && (
        <StyledRequired surfaceColor={surfaceColor} aria-hidden="true">
          *
        </StyledRequired>
      )}
      {placeholder && labelPosition === 'internal' && (
        <StyledInternalPlaceholder surfaceColor={surfaceColor} aria-hidden="true">
          {placeholder}
        </StyledInternalPlaceholder>
      )}
    </StyledLabel>
  )
}
